export default __webpack_public_path__ + "media/src/assets/images/MapPinOutbound-95a27d79edca5d26acf7972b7b74733d.svg";